<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-6">
          <h4 class="card-title">Procurement</h4>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                v-model="itemsPerPage"
                size="sm"
                :options="itemsPageOptions"
              ></b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>

        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div
            id="tickets-table_filter"
            class="dataTables_filter text-md-right"
          >
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="itemsFilter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="table-responsive mb-0 " style="text-align:center">
        <b-table
          :items="tableData"
          :fields="fields"
          responsive="sm"
          :per-page="itemsPerPage"
          :current-page="itemsCurrentPage"
          :sort-by.sync="itemsSortBy"
          :sort-desc.sync="itemsSortDesc"
          :sort-compare="tableSort"
          :filter="itemsFilter"
          :filter-included-fields="itemsFilterOn"
          :totalQuotedAmount="totalQuotedAmount"
          :totalReceivedAmount="totalReceivedAmount"
        >
          <template v-slot:cell(date)="data">
            <div>
              <span> {{ data.value.toString().substring(4, 15) }}</span>
            </div>
          </template>

          <template v-slot:cell(markup)="data">
            <div>
              <span
                v-if="
                  data.value !== '' &&
                    (data.item.markupType === 'flatRate' ||
                      data.item.markupType === 'dollar')
                "
                >$</span
              >{{ data.value
              }}<span
                v-if="
                  data.value !== '' && data.item.markupType === 'percentage'
                "
                >%</span
              >
            </div>
          </template>
          <template v-slot:cell(ordered)="data">
            <div>
              <span
                v-b-tooltip.hover
                :title="
                  data.value.value && data.value.time
                    ? `${
                        data.value.name
                      } on ${data.value.time.toString().substring(4, 21)}`
                    : null
                "
                ><b-badge :variant="data.value.value ? 'success' : 'danger'">{{
                  data.value.value ? 'Yes' : 'No'
                }}</b-badge></span
              >
            </div>
          </template>
          <template v-slot:cell(received)="data">
            <div>
              <span
                v-b-tooltip.hover
                :title="
                  data.value.value && data.value.time
                    ? `${
                        data.value.name
                      } on ${data.value.time.toString().substring(4, 21)}`
                    : null
                "
                ><b-badge :variant="data.value.value ? 'success' : 'danger'">{{
                  data.value.value ? 'Yes' : 'No'
                }}</b-badge></span
              >
            </div>
          </template>
          <template v-slot:cell(invoiced)="data">
            <div>
              <span
                v-b-tooltip.hover
                :title="
                  data.value.value && data.value.time
                    ? `${
                        data.value.name
                      } on ${data.value.time.toString().substring(4, 21)}`
                    : null
                "
                ><b-badge :variant="data.value.value ? 'success' : 'danger'">{{
                  data.value.value ? 'Yes' : 'No'
                }}</b-badge></span
              >
            </div>
          </template>
          <template v-slot:cell(quoteImage)="data">
            <div v-if="data.item.quoteImage">
              <b-button
                @click="openImage(data.value.quoteURL)"
                variant="primary"
              >
                View
              </b-button>
            </div>
          </template>
          <template v-slot:cell(invoiceImage)="data">
            <div v-if="data.item.invoiceImage">
              <b-button
                @click="openImage(data.value.invoiceURL)"
                variant="primary"
              >
                View
              </b-button>
            </div>
          </template>
          <template v-slot:cell(billable)="data">
            <b-badge
              :variant="!data.item.billable.value ? 'success' : 'danger'"
              >{{ !data.item.billable.value ? 'Yes' : 'No' }}</b-badge
            >
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="itemsCurrentPage"
                :total-rows="itemsTotalRows"
                :per-page="itemsPerPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { tableSort } from '../../helper/helpers';

import VueToast from 'vue-toast-notification';
// Import one of the available themes
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

export default {
  data() {
    return {
      name: 'ProcurementReportTable',

      itemsCurrentPage: 1,
      itemsPerPage: 10,
      itemsPageOptions: [10, 25, 50, 100],
      itemsFilter: null,
      itemsFilterOn: [],
      itemsSortBy: 'date',
      itemsSortDesc: true,

      fields: [
        {
          key: 'date',
          sortable: true,
        },
        {
          key: 'jobNum',
          sortable: true,
        },
        {
          key: 'name',
          sortable: true,
        },
        {
          key: 'customer',
          sortable: true,
        },
        { key: 'Billable', sortable: true, class: 'billable.value' },
        {
          key: 'quotedAmount',
          sortable: true,
        },
        {
          key: 'receivedAmount',
          sortable: true,
        },
        {
          key: 'markup',
          label: 'Mark-up',
          sortable: true,
        },
        { key: 'type', sortable: true },
        {
          key: 'ordered',
          sortable: true,
        },
        {
          key: 'received',
          sortable: true,
        },
        {
          key: 'invoiced',
          sortable: true,
        },
        { key: 'quoteImage', sortable: false },
        { key: 'invoiceImage', sortable: false },
      ],
    };
  },
  props: {
    tableData: Array,
    totalQuotedAmount: Number,
    totalReceivedAmount: Number,
  },
  methods: {
    tableSort: tableSort,
    openImage: function(url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
  },
  computed: {
    itemsTotalRows() {
      return this.tableData.length;
    },
  },
};
</script>
